import VideoPlayer from "@/components/VideoPlayer"
import { urlForImage } from "@/sanity/lib/image"
import Image from "next/image"

interface ProjectCoverProps {
	media: any
}

export default function ProjectCover({media}:ProjectCoverProps) {

	return (
		<div className="px-site-margin mt-[4rem] md:mt-[8rem]">
			<div className="relative w-full aspect-video rounded-weak overflow-clip">
				{media?.type === 'image' && (
					<Image
						className={`w-full h-full object-cover`}
						src={urlForImage(media?.image).url()}
						width={media?.image?.asset?.metadata?.dimensions?.width}
						height={media?.image?.asset?.metadata?.dimensions?.height}
						sizes="100vw"
						alt={media?.image?.alt || ''}
						placeholder="blur"
						blurDataURL={media?.image?.asset?.metadata?.lqip}
						unoptimized={media?.image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
					/>
				)}

				{media?.type === 'video' && media?.video?.asset?.playbackId && (
					<VideoPlayer
						playbackId={media?.video?.asset?.playbackId}
						showAudioToggle={media?.showAudioToggle}
						autoplay={true}
						loop={true}
						posterTime={media?.posterTime}
					/>
				)}
			</div>
		</div>
	)
}